import { AppShell } from "@/components/app/AppShell";
import { OrgTeam } from "@/pages/Console";
import { useAuth } from "@/context/AuthContext";

export default function Team() {
  const { user } = useAuth();
  return (
    <AppShell eyebrow={`— ${(user.org_name || "").toUpperCase()}`} title="Team">
      <OrgTeam />
    </AppShell>
  );
}
